import React, { useEffect, useCallback } from 'react';
import PanelEditUser from '../../Components/PanelEditUser';
import Modal from 'react-modal';
import './styles.css'
import api from '../../Services/api';
import { useAblContext } from '../../Hooks/useAblContext';

interface User {
  id: string;
  name: string;
  updatedAt: Date;
  email: string;
  watched: number;
}

Modal.setAppElement('#root')

export default function User() {
  const [showAddUser, setShowAddUser] = React.useState(false);
  const [users, setUsers] = React.useState<User[]>([]);

  const abl = useAblContext();

  const requestUsers = async () => {
    try{
      const response = await api.get('user', { headers: { authorization: abl.token }})//.then(
      const responseWatched = await api.get('video/watch/', { headers: { authorization: abl.token }})

      if(response.data.length) {
        const users = response.data;
        if(responseWatched.data) {
          const videos = responseWatched.data.sumary;
            if(!videos) {
              return setUsers(users);
            }
            const parsed = users.map((user: any) => {
              const watchedMovie = videos.filter((watched: any) => watched.userId === user.id)
              console.log('watchedMovie: ', watchedMovie);
              let summarized = 0
              if(watchedMovie[0] != undefined){
                summarized = watchedMovie[0].summarized || 0
              }
              return {
                ...user,
                watched: summarized
              }
              //watchedMovie[0].summarized || 0,
            })
            return setUsers(parsed);
        }
        return setUsers(users)
      }

      return [];
    } catch(err) {
      console.log(err);
    }

  }

  useEffect(() => {
    (
      async () => {
        await requestUsers()
      }
    )();
  }, [])

  const handleCloseModal = useCallback(() => {
    setShowAddUser(false);
  }, [])

  const handleUpdateUsers = (user: User) => {
    let usersCopy = new Array<User>();
    usersCopy.push(...users, user);
    setUsers(usersCopy);
  }

  const handleDeleteUser = async (id: string) => {
    const deleted = await api.delete(`user/${id}`, { headers: { authorization: abl.token }})
    await requestUsers();
  }

  return(
    <>
        <PanelEditUser show={showAddUser} onClose={handleCloseModal} onUserCreate={handleUpdateUsers}/>
      <div className="container">
        <a className="btn btn-primary" data-toggle="collapse" data-target="#abre" onClick={() => setShowAddUser(true)}>Adicionar Usuário Banca</a>
        <div className="row collapse" id="abre">
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
              <form method="post" action="#">
                <div className="form-group">
                  <label>Nome</label>
                  <input type="text" name="nome" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>E-mail</label>
                  <input type="text" name="email" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>Login</label>
                  <input type="text" name="login" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>Senha</label>
                  <input type="password" name="senha" className="form-control"/>
                </div>
                <input name="enviar" type="submit" value="Adicionar"/>
              </form>
            </div>
          </div>
        </div>
      </div>

      <h3 className="text-center">USUÁRIOS DA BANCA</h3>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
            <table className="table">
              <thead>
                <tr>
                <td align="left" height="45"><b>NOME</b></td>
                  <td align="left" height="45"><b>E-MAIL</b></td>
                  <td width="150" align="center"><b>FILMES ASSISTIDOS</b></td>
                  <td width="250" align="center"><b>ÚLTIMO ACESSO</b></td>
                  <td width="80" align="center"><b>EDITAR</b></td>
                  <td width="80" align="center"><b>EXCLUIR</b></td>
                </tr>
              </thead>
              <tbody>
                { users.map((user: User, _: number) => {
                  return(
                  <tr key={_}>
                    <td align="left" height="45">{user.name}</td>
                      <td align="left" height="45">{user.email}</td>
                      <td width="250px" align="center">{user.watched || 0}</td>
                      <td width="250px" align="center">{user.updatedAt}</td>
                      <td width="80px" align="center">
                        <a href="editarUsuario.php" className="btn btn-warning btn-sm">
                          <i className="glyphicon glyphicon-pencil"></i>
                        </a>
                      </td>
                      <td width="80px" align="center">
                          <a className="btn btn-danger btn-sm" onClick={() => handleDeleteUser(user.id)}>
                            <i className="glyphicon glyphicon-trash"></i>
                          </a>
                      </td>
                    </tr>)
                  })
                }
              </tbody>
            </table>
            </div>
          </div>
        </div>
		  </div>
    </>
  )
}
